export default __webpack_public_path__ + "static/media/pic_1.66b82260.webp";